// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"5a04ad64a0b81bb8ff08","691":"a9f1a9101e9ed2687a1f"}[chunkId] + ".js";
};